import React, { Component } from 'react';
import PropTypes from 'prop-types';
import VersionSection from '../components/VersionSection';
import FixedData from '../components/FixedData';
import styled from 'styled-components';
import { SidePanelActions, InputField } from 'cx-ui-components';

const StyledHeader = styled.h3`
  font-size: 28px;
  color: #474747;
  font-weight: 700;
  margin-bottom: 30px;
`;

const StyledSidePanelActions = styled(SidePanelActions)`
  padding-top: 10px;
  padding-bottom: 20px;
`;

export default function AlpsCreateVersionForm({
  key,
  handleSubmit,
  actionTypes,
  invalid,
  isSaving,
  artifactTypeName,
  artifactSubType,
  activeAction,
  typeHasSubtypes,
  setSelectedSubEntityId
}) {
  return (
    <form onSubmit={handleSubmit} key={key}>
      <StyledHeader>
      Create a new Artifacts Lifecycle Policy version.
      </StyledHeader>
      <FixedData label="Artifact Type *" value={artifactTypeName} />

      {typeHasSubtypes && <FixedData label="Artifact Subtype *" value={artifactSubType} />}

      <InputField
        name="versionName"
        label="Version Name *"
        id="frm-alps-name"
        data-automation="nameInput"
        componentType="input"
        inputType="text"
        required
      />

      <VersionSection actionTypes={actionTypes} activeAction={activeAction} disabled={isSaving} />

      <StyledSidePanelActions
        onCancel={() => setSelectedSubEntityId(undefined)}
        isSaving={isSaving}
        invalid={invalid}
      />
    </form>
  );
}

AlpsCreateVersionForm.propTypes = {
  key: PropTypes.string,
  handleSubmit: PropTypes.func.isRequired,
  setSelectedSubEntityId: PropTypes.func,
  actionTypes: PropTypes.array,
  artifactTypeName: PropTypes.string,
  artifactSubtype: PropTypes.string,
  invalid: PropTypes.bool,
  isSaving: PropTypes.bool,
};
